import { createAction } from '@reduxjs/toolkit'

import { TShowNPS } from 'types/GlobalNPS'

// tryGetShowNps, tryCreateSurvey (actions/Surveys)
export const setShowNps = createAction<TShowNPS>('set_show_nps')
